export default __webpack_public_path__ + "static/unity-3810229e762015673e06cf20eff96793.png";